/// <reference path="../../../node_modules/@types/adal-angular/index.d.ts" />
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as AuthenticationContext from 'adal-angular';
import { Observable, Subscriber, config } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ConfigService } from './config.service';
// let createAuthContextFn: adal.AuthenticationContextStatic = AuthenticationContext;

@Injectable()
export class AdalService {
	private context: AuthenticationContext;
	// private _config: adal.Config;
	// private adalService: adal.Logging;

	constructor(private configService: ConfigService, private http: HttpClient) {
		this.context = new AuthenticationContext(configService.getAdalConfig);
	}

	get config() {
		return this.configService.getAdalConfig;
	}

	login() {
		this.context.login();
	}

	logout() {
		this.context.logOut();
		this.context.clearCache();
		localStorage.removeItem('token');
	}

	handleCallback() {
		this.context.handleWindowCallback();
	}

	public get userInfo() {
		return this.context.getCachedUser();
	}

	public get accessToken() {
		return this.context.getCachedToken(this.configService.getAdalConfig.clientId);
	}

	public get isAuthenticated() {
		return this.userInfo;
	}

	public get loginInProgress() {
		return this.context.loginInProgress();
	}

	public acquireToken(resource?: string): Observable<any> {
		const adalContext = this;
		return new Observable<any>((subscriber: Subscriber<any>) =>
			this.context.acquireToken(resource, function (errorDesc, token, error) {
				adalContext.handleCallback();
				// localStorage.setItem("token", token);
				if (errorDesc) {
					adalContext.acquireTokenRedirect(resource);
				}
				subscriber.next(token);
			})
		);
	}

	private acquireTokenRedirect(resource) {
		this.context.acquireTokenRedirect(resource);
	}

	public get(resource: string, url: string): Observable<any> {
		return this.acquireToken(resource)
			.pipe(
				switchMap(
					token => this.http.get(url, { headers: { 'Authorization': `Bearer ${token}` } }
					))
			);
	}
}
